import {
  GetItemsSortBy,
  ItemsWithPagination,
  SortOrder
} from '@inno-sdks/files'
import { useQuery } from '@tanstack/react-query'

import { initFilesSdk } from '../filesSdk'
import { useAppFolderId } from './useAppFolderId'

export const FILES_LIST_QUERY_KEY = 'files-list'

interface Props {
  enabled?: boolean
  onSuccess?: (rootFolderItems: ItemsWithPagination) => void
}

export const useFilesList = ({ onSuccess, enabled = true }: Props = {}) => {
  const { filesSdk, success } = initFilesSdk()
  const { data: folderId } = useAppFolderId()

  return useQuery({
    queryKey: [FILES_LIST_QUERY_KEY, folderId],
    queryFn: async () => {
      if (!filesSdk || folderId == null) return

      const rootFolder = await filesSdk.items.getAll({
        filters: {
          parentFolderId: folderId,
          sortBy: GetItemsSortBy.CreatedAt,
          sortOrder: SortOrder.Ascending
        }
      })

      onSuccess?.(rootFolder)

      return rootFolder
    },

    // Provisioning decisions are based on this response. Always refresh when
    // the desktop mounts so a shortcut deleted outside the app is recreated
    // instead of being hidden by a still-fresh React Query cache entry.
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    staleTime: 1000 * 60 * 3,
    enabled: success && enabled && folderId != null
  })
}
